import { lowerCase } from "lodash";
import { CatalogTemplateItem, Unit } from "types";

export const isXolaDemographic = (demographic?: Unit | CatalogTemplateItem) => {
    if (!demographic) return false;

    return !!(demographic.code ?? (demographic as Unit).sku);
};

export const isCustomDemographic = (demographic?: Unit | CatalogTemplateItem) => !isXolaDemographic(demographic);

/**
 * These are the default demographics that xola uses for translations (as per V1)
 * Note: use this only for translations, else use above function
 */
export const isDefaultDemographic = (name = "") => {
    return ["adults", "veterans", "children", "seniors", "guests"].includes(lowerCase(name));
};
